'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { DocumentTagLink } from '@/ui/links/document-tag-link/DocumentTagLink.client'
import { gql } from '@gql-generated/gql'
import type { Document, ProductDocuments_DocumentsFragment } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  fragment ProductDocuments_Documents on Document {
    name
    link
  }
`)

type StrictDocument = StrictOmit<Document, 'name' | 'link'> & {
  name: string
  link: string
}

export type ProductDocumentsProps = {
  documents: NonNullable<ProductDocuments_DocumentsFragment[]>
}

export function ProductDocuments({ documents }: ProductDocumentsProps) {
  const { t } = useTranslation(['generic', 'productDocuments'])
  const filteredDocuments = documents.filter(
    (document): document is StrictDocument =>
      typeof document.name === 'string' && typeof document.link === 'string',
  )

  if (!filteredDocuments.length) {
    return null
  }

  return (
    <>
      {/* TODO uniformisation des title de ProductDetailsInfosSection */}
      <span className="text-xl font-bold leading-light text-brand-2-900">
        {t('productDocuments:title')}
      </span>

      <div className="flex flex-wrap gap-2">
        {filteredDocuments.map((document) => (
          <DocumentTagLink
            key={`${document.name}-${document.link}`}
            downloadLink={document.link}
            label={document.name}
          />
        ))}
      </div>
    </>
  )
}
